import Chip from '@mui/material/Chip';
import styled from 'styled-components';

export const StyledChip = styled(Chip)`
  font-size: 11px;
`;
